import { IAssets } from '@sparling/financial-common'

export interface IEnum {
  value: string
  label: string
}

export interface IAssetEnum {
  value: number
  label: string
}

export const createEnum = (input: string[] | Record<string, string>): IEnum[] =>
  (Array.isArray(input) ? input : Object.values(input)).map((item) => ({ value: item, label: item }))

export const convertAssetsEnum = (input: IAssets[]): IAssetEnum[] =>
  input.map((item: IAssets) => ({
    value: item.id,
    label: item.label,
  }))
